import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Home from "./Pages/Home";
import Events from "./Pages/Events";
import FAQs from "./Pages/FAQs";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route>
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/" element={<Home />} />
          {/* <Route path="*" element={<Home />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
